import { Stack } from "expo-router"

import { MicrophoneProvider } from "src/context/MicrophoneContext"
import { UnauthChatProvider } from "src/context/UnauthChatProvider"
import { UnauthSidekickInteractionProvider } from "src/context/UnauthSidekickInteractionProvider"
import { UnauthVisemeProvider } from "src/context/UnauthVisemeProvider"
import { UnauthWebsocketProvider } from "src/context/UnauthWebsocketProvider"
import { TypingProvider } from "src/context/TypingContext"
import { useAppTheme } from "src/hooks/useAppTheme"

export default function RootLayout() {
  const {
    theme: { colors },
  } = useAppTheme()
  return (
    <UnauthWebsocketProvider>
      <MicrophoneProvider>
        <TypingProvider>
          <UnauthChatProvider>
            <UnauthSidekickInteractionProvider>
              <UnauthVisemeProvider>
                <Stack
                  screenOptions={{
                    headerShown: false,
                    navigationBarColor: colors.background,
                    contentStyle: {
                      backgroundColor: colors.background,
                    },
                  }}
                  initialRouteName="login"
                >
                  <Stack.Screen name="login" />
                  <Stack.Screen
                    name="forgot-password"
                    options={{
                      presentation: "fullScreenModal",
                    }}
                  />
                  <Stack.Screen
                    name="reset-password"
                    options={{
                      presentation: "fullScreenModal",
                    }}
                  />
                  <Stack.Screen
                    name="update-password"
                    options={{
                      presentation: "fullScreenModal",
                    }}
                  />
                  {/* Media-first channel screens — no authentication required */}
                  <Stack.Screen name="channel-splash/[id]" />
                  <Stack.Screen name="channel-library/[id]" />
                  <Stack.Screen name="media-viewer" />
                </Stack>
              </UnauthVisemeProvider>
            </UnauthSidekickInteractionProvider>
          </UnauthChatProvider>
        </TypingProvider>
      </MicrophoneProvider>
    </UnauthWebsocketProvider>
  )
}
